import { useEffect } from "react";
import type { RefObject } from "react";

/**
 * Invoke `handler` on a mousedown outside the referenced element.
 * Pass `active=false` to disable the listener (e.g. while a menu is closed).
 */
export function useClickOutside<T extends HTMLElement>(
  ref: RefObject<T | null>,
  handler: () => void,
  active = true,
): void {
  useEffect(() => {
    if (!active) return;
    function onMouseDown(event: MouseEvent) {
      if (ref.current && !ref.current.contains(event.target as Node)) handler();
    }
    document.addEventListener("mousedown", onMouseDown);
    return () => document.removeEventListener("mousedown", onMouseDown);
  }, [ref, handler, active]);
}
